<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main max-w" id="page-content-main">
    <div class="" style="padding-bottom:1vh;">
      <epay-library-employer-eft-createfile [baseurl]="baseurl" [termsContent]="termsContent" [clientName]="clientName"
        [routingHelpImage]="routingHelpImage">
      </epay-library-employer-eft-createfile>
    </div>
  </div>
</epay-page-content>
